import clsx from 'clsx';

import styles from './Icon.module.scss';
export type { DesignSystemIconName } from './designSystemIconMap';

export enum DesignSystemIconSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum DesignSystemIconTone {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ACCENT = 'accent',
  ON_COLOR = 'on_color',
  DISABLED = 'disabled',
  DANGER = 'danger',
}

type GetIconClassesOptions = {
  size?: DesignSystemIconSize;
  tone?: DesignSystemIconTone;
  className?: string;
};

const iconSizeValueBySize: Record<DesignSystemIconSize, number> = {
  [DesignSystemIconSize.SMALL]: 16,
  [DesignSystemIconSize.MEDIUM]: 20,
  [DesignSystemIconSize.LARGE]: 24,
};

export const getIconSizeValue = (
  size = DesignSystemIconSize.MEDIUM,
): number => {
  return iconSizeValueBySize[size];
};

export const getIconClasses = ({
  size = DesignSystemIconSize.MEDIUM,
  tone = DesignSystemIconTone.PRIMARY,
  className,
}: GetIconClassesOptions): string => {
  return clsx(styles.icon, styles[size], styles[tone], className);
};
